import React, {useCallback, useEffect, useState} from 'react';
import {useForm, router} from "@inertiajs/react";
import {route} from "ziggy-js";
import useWithStore from "@/Hooks/useWithStore";
import Dialog from "@mui/material/Dialog";
import {Error} from "@/Components/Error";
import Checkbox from "@/Components/Checkbox";
import Radio from "@/Components/form/Radio";
import Svg from "@/Components/Svg";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import isEmpty from "is-empty";
import TextAgreementCreateAccount from "@/Components/TextAgreementCreateAccount";
import TextAgreement from "@/Components/TextAgreement";
import {getClientId} from "@/Helpers/Function";
import Select from "react-select";
import InertiaTextInput from "@/Components/Inertia/InertiaTextInput";

const maxSteps = 2;
const stepOneTitle = 'Выберите номинал';
const stepTwoTitle = 'Оформите подарочный сертификат';

const ModalBuyGiftCertificate = (props) => {
    const {stores = {}, nominalListStart = [], whenToSend = [], user = {}, config = {}} = props;
    const {modalStore = {}, giftCertificateStore = {}} = stores;
    const {ymId = null, russianTimezones = []} = config;

    const [step, setStep] = useState(1);
    const [title, setTitle] = useState(stepOneTitle);
    const [stepPercentage, setStepPercentage] = useState((step / maxSteps * 100).toFixed(4));
    const initialValues = {
        name: user.name ?? '',
        phone: user.phone ?? '',
        email: user.email ?? '',
        recipient_name: '',
        recipient_phone: '',
        recipient_email: '',
        recipient_message: '',
        recipientSwitch: false,
        whenToSendSwitch: whenToSend[0],
        date: '',
        time: '',
        timezone: '',
        template: 0,
        total: 0,
        smsCode: '',
        errorMessage: '',
        source_from: 'certificate_web',
        payment_method: 'online',
        clientId: null,
    };

    const form = useForm(initialValues);
    const {data, setData, post, processing, errors, setError, clearErrors, transform} = form;

    useEffect(() => {
        giftCertificateStore.nominalList = nominalListStart;
    }, [nominalListStart]);

    useEffect(() => {
        if (data.total !== 0 && errors.total) {
            clearErrors('total');
        }
    }, [data.total, errors.total]);

    // Если ввели свой номинал, помечаем выбранным
    useEffect(() => {
        if (giftCertificateStore.nominalData.length !== 0) {
            setData('total', giftCertificateStore.nominalData[0]);
        }
    }, [giftCertificateStore.nominalData]);

    const changeStep = (e, vidOperation, title) => {
        e.preventDefault();
        if (data.total === 0) {
            return setError('total', 'Выберите номинал сертификата из предложенных или добавьте свой!');
        }

        const newStep = eval(step + vidOperation + 1);
        if (newStep < 1 || newStep > maxSteps) {
            return;
        }

        setStep(newStep);
        setTitle(title);
        setStepPercentage((newStep / maxSteps * 100).toFixed(4));
    };

    const addOrRemoveDataNominal = (el) => {
        setData('total', el);
    };

    const NominalList = useCallback(() => {
        if (giftCertificateStore.nominalList.length === 0) {
            return null;
        }

        return <>
            {giftCertificateStore.nominalList.map((el, i) => {
                const active = el === data.total;
                return <div key={i}
                            className={`stepOneContainer__list_item${active ? ' active' : ''}`}
                            onClick={() => addOrRemoveDataNominal(el)}>
                    <p className={`amount`}>
                        {el.toLocaleString('ru')}&nbsp;₽
                    </p>
                </div>
            })}
        </>
    }, [giftCertificateStore.nominalData, giftCertificateStore.nominalList, data, errors]);

    const onHandleChange = (event) => {
        if (event.value) {
            setData('timezone', event.value);
        } else {
            setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
        }
    };

    transform((data) => ({
        ...data,
        template: giftCertificateStore.template,
        clientId: getClientId(ymId),
    }));

    const getCodeBySms = (e) => {
        e.preventDefault();

        post(route('certificateSendSms'), {
            onSuccess: (page) => {
                //
            },
            onError: errors => {
                //
            },
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        post(route('createCertificate'), {
            onSuccess: (page) => {
                processingSuccessfulResponse(page.props.success);
            },
            onError: errors => {
                //
            },
        });
    };

    /**
     * Обработка успешного заказа
     * @param success
     */
    const processingSuccessfulResponse = (success = {}) => {
        const {redirectUrl = ''} = success;

        // Если оплата онлайн, кидаем на страницу банка
        if (redirectUrl !== '') {
            return router.visit('/home?profile=orders', {
                onSuccess: (visit) => {
                    location.assign(redirectUrl);
                }
            });
        }
    }

    return <Dialog id={`modal`}
                   className={`modal modalBuyGiftCertificate`}
                   open={modalStore.flagModalBuyGiftCertificate}
                   onClose={() => modalStore.closeModalBuyGiftCertificate()}
                   aria-labelledby={`form-dialog-title`}
                   maxWidth={`md`} //xs sm md lg xl
                   fullWidth>
        <div className={`modal__header`}>
            <div className={`dagger-box`} onClick={() => modalStore.closeModalBuyGiftCertificate()}>
                <Svg id={`dagger-close`} className={`svg__dagger-close`} />
            </div>
            <div className={`modal-title`}>{title}</div>
        </div>
        <div className={`modal__body modal__body_buyGiftCertificate`}>
            <form className={`form form__createCertificate`} onSubmit={handleSubmit}>
                <div className={`steps`}>
                    <p>Шаг {step} из {maxSteps}</p>
                    <div className={`steps__linearProgressParent`}>
                        <div className={`steps__linearProgressChildren`} style={{width: stepPercentage + '%'}}></div>
                    </div>
                </div>
                {step === 1 && (
                    <>
                        <div className={`stepOneContainer`}>
                            <button className={`btn`} onClick={(e) => modalStore.openModalAddNominal(e)}>
                                + Свой номинал
                            </button>
                            <div className={`stepOneContainer__list`}>
                                <NominalList />
                            </div>
                        </div>
                        <Error message={errors.total} className={`validation`} />
                        <p className={`modal-title`}>Выберите дизайн</p>
                        <div className={`designContainer`}>
                            <Slider {...props} />
                        </div>
                        <div className={`buttonContainer`}>
                            <button className={`btn btn__giftCertificate${step === 1 ? ' btn__disabled' : ''}`}
                                    onClick={(e) => changeStep(e, '-', stepOneTitle)}>
                                Назад
                            </button>
                            <button className={`btn btn__giftCertificate${step === maxSteps ? ' btn__disabled' : ''}`}
                                    onClick={(e) => changeStep(e, '+', stepTwoTitle)}>
                                Далее
                            </button>
                        </div>
                    </>
                )}
                {step === 2 && (
                    <div className={`stepTwoContainer${processing ? ' load' : ''}`}>
                        <div className={`fromWhom`}>
                            <p className={`fromWhom__title`}>От кого?</p>
                            <p className={`fromWhom__text`}>Укажите данные отправителя</p>
                            <div className={`form__itemNew`}>
                                <input name={`name`}
                                       type={`text`}
                                       placeholder={`Имя *`}
                                       value={data.name}
                                       onChange={onHandleChange}
                                       className={`text-inputNew${errors.name ? ' error' : ''}`}
                                       disabled={!isEmpty(user.name)}
                                />
                                <label className={`text-labelNew`}>Имя *</label>
                                <Error message={errors.name} />
                            </div>
                            <InertiaTextInput
                                name={`phone`}
                                type={`tel`}
                                mask={`+7 (999) 999 99 99`}
                                label={`Телефон *`}
                                form={form}
                                disabled={!isEmpty(user.phone)}
                            />
                            <div className={`form__itemNew`}>
                                <input name={`email`}
                                       type={`email`}
                                       placeholder={`Email *`}
                                       value={data.email}
                                       onChange={onHandleChange}
                                       className={`text-inputNew${errors.email ? ' error' : ''}`}
                                       disabled={!isEmpty(user.email)}
                                />
                                <label className={`text-labelNew`}>Email *</label>
                                <Error message={errors.email} />
                            </div>
                        </div>
                        <div className={`toWhom`}>
                            <div className={`toWhom__header`}>
                                <p className={`toWhom__title`}>Кому?</p>
                                <div className={`form__itemCheckbox`}>
                                    <Checkbox name={`recipientSwitch`}
                                              checked={data.recipientSwitch}
                                              onChange={onHandleChange}
                                              label={`Оформить себе`}
                                              textPosition={`left`}
                                    />
                                </div>
                            </div>
                            {!data.recipientSwitch && (
                                <p className={`toWhom__text`}>
                                    Укажите данные получателя для оформления подарочного сертификата
                                </p>
                            )}
                            {!data.recipientSwitch && (
                                <>
                                    <div className={`form__itemNew`}>
                                        <input name={`recipient_name`}
                                               type={`text`}
                                               placeholder={`Имя получателя *`}
                                               value={data.recipient_name}
                                               onChange={onHandleChange}
                                               className={`text-inputNew${errors.recipient_name ? ' error' : ''}`}
                                        />
                                        <label className={`text-labelNew`}>Имя получателя *</label>
                                        <Error message={errors.recipient_name} />
                                    </div>
                                    <InertiaTextInput
                                        name={`recipient_phone`}
                                        type={`tel`}
                                        mask={`+7 (999) 999 99 99`}
                                        label={`Телефон *`}
                                        form={form}
                                    />
                                    <div className={`form__itemNew`}>
                                        <input name={`recipient_email`}
                                               type={`email`}
                                               placeholder={`Email *`}
                                               value={data.recipient_email}
                                               onChange={onHandleChange}
                                               className={`text-inputNew${errors.recipient_email ? ' error' : ''}`}
                                        />
                                        <label className={`text-labelNew`}>Email *</label>
                                        <Error message={errors.recipient_email} />
                                    </div>
                                </>
                            )}
                            <div className={`form__itemNew`}>
                                    <textarea name={`recipient_message`}
                                              value={data.recipient_message}
                                              onChange={onHandleChange}
                                              className={`text-inputNew text-inputNew__commentNew`}
                                              placeholder={`Добавьте тёплых слов`}
                                    />
                                <label className={`text-labelNew`}>Добавьте тёплых слов</label>
                                <Error message={errors.recipient_message} />
                            </div>
                        </div>
                        <div className={`whenToSend`}>
                            <p className={`whenToSend__title`}>Когда отправить?</p>
                            <p className={`whenToSend__text`}>
                                Сертификат будет отправлен на email и в SMS-сообщении получателю сразу после оплаты, или
                                вы можете указать дату и время получения.
                            </p>
                            <div className={`form__itemRadio`}>
                                <Radio name={`whenToSendSwitch`}
                                       value={`sendNow`}
                                       checked={data.whenToSendSwitch === 'sendNow'}
                                       onChange={onHandleChange}
                                       label={`Отправить сразу после оплаты`}
                                />
                                <Radio name={`whenToSendSwitch`}
                                       value={`sendLater`}
                                       checked={data.whenToSendSwitch === 'sendLater'}
                                       onChange={onHandleChange}
                                       label={`Указать дату и время получения`}
                                />
                            </div>
                            <Error message={errors.whenToSendSwitch} />
                            {data.whenToSendSwitch === 'sendLater' && (
                                <>
                                    <div className={`input-group`}>
                                        <div className={`form__itemNew form__itemNew_half`}>
                                            <input
                                                name={`date`}
                                                type={`date`}
                                                placeholder={`Дата *`}
                                                value={data.date}
                                                onChange={onHandleChange}
                                                className={`text-inputNew${errors.date ? ' error' : ''}`}
                                            />
                                            <label className={`text-labelNew`}>Дата *</label>
                                            <Error message={errors.date} />
                                        </div>
                                        <div className={`form__itemNew form__itemNew_half`}>
                                            <input
                                                name={`time`}
                                                type={`time`}
                                                placeholder={`Время *`}
                                                value={data.time}
                                                onChange={onHandleChange}
                                                className={`text-inputNew${errors.time ? ' error' : ''}`}
                                            />
                                            <label className={`text-labelNew`}>Время *</label>
                                            <Error message={errors.time} />
                                        </div>
                                    </div>
                                    <div className={`form__item`}>
                                        <Select
                                            name={`subjectName`}
                                            onChange={onHandleChange}
                                            options={russianTimezones}
                                            maxMenuHeight={160}
                                            isSearchable
                                            placeholder={`Часовой пояс`}
                                            noOptionsMessage={() => ('Не найдено')}
                                            theme={theme => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: '#B1CBC3',
                                                    primary: 'black',
                                                },
                                            })
                                            }
                                        />
                                        <Error message={errors.subjectName} />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className={`paymentMethodContainer form__itemRadio`}>
                            <p className={`paymentMethodContainer__title`}>Способ оплаты</p>
                            <Radio name={`payment_method`}
                                   value={`online`}
                                   checked={data.payment_method === 'online'}
                                   onChange={onHandleChange}
                                   label={`Банковской картой онлайн`}
                            />
                            <Radio name={`payment_method`}
                                   value={`sbp`}
                                   checked={data.payment_method === 'sbp'}
                                   onChange={onHandleChange}
                                   label={`Оплата через СБП`}
                            />
                        </div>
                        <div className={`resultContainer`}>
                            <div className={`resultContainer__header`}>
                                Ваш заказ:
                            </div>
                            <p className={`resultContainer__body`}>
                                Подарочный сертификат
                                на {data.total.toLocaleString('ru')}&nbsp;₽
                            </p>
                            <div className={`resultContainer__footer`}>
                                <p>К оплате</p>
                                <p>{data.total.toLocaleString('ru')}&nbsp;₽</p>
                            </div>
                        </div>
                        <div className={`smsContainer`}>
                            <button className={`btn btn__giftCertificate`}
                                    onClick={(e) => getCodeBySms(e)}
                                    type={`submit`}>
                                Получить код по смс
                            </button>
                            <div className={`form__itemNew form__itemNew_giftCertificate`}>
                                <input
                                    name={`smsCode`}
                                    type={`text`}
                                    placeholder={`Код из смс *`}
                                    value={data.smsCode}
                                    onChange={onHandleChange}
                                    className={`text-inputNew${errors.smsCode ? ' error' : ''}`}
                                />
                                <label className={`text-labelNew`}>Код из смс *</label>
                                <Error message={errors.smsCode} />
                            </div>
                        </div>
                        <Error message={errors.errorMessage} className={`validation`} />
                        {isEmpty(user.card_number) ?
                            <TextAgreementCreateAccount textButton={`Оплатить`} />
                            :
                            <TextAgreement textButton={`Оплатить`} />
                        }
                        <div className={`buttonContainer`}>
                            <button className={`btn btn__giftCertificate${step === 1 ? ' btn__disabled' : ''}`}
                                    onClick={(e) => changeStep(e, '-', stepOneTitle)}>
                                Назад
                            </button>
                            <button className={`btn btn__giftCertificate`} type={`submit`} disabled={processing}>
                                Оплатить
                            </button>
                        </div>
                    </div>
                )}
            </form>
        </div>
    </Dialog>;
};

const Slider = ({design = [], stores = {}}) => {
    const {giftCertificateStore = {}} = stores;

    if (design.length === 0) {
        return null;
    }

    const params = {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        initialSlide: giftCertificateStore.template,
        onSlideChange: (swiper) => {
            giftCertificateStore.template = swiper.activeIndex;
        }
    };

    return (
        <Swiper className={`swiperCertificateDesign`}
                navigation={true}
                modules={[Navigation]}
                {...params}
        >
            {design.map((el, i) => {
                return <SwiperSlide key={i}>
                    <picture className={`guarantee-picture`}>
                        <source type={`image/webp`} srcSet={el.pathWebp} />
                        <img src={el.path} alt={`design-certificate`} />
                    </picture>
                    <div className={`swiper-lazy-preloader`} />
                </SwiperSlide>
            })}
        </Swiper>
    );
};

export default useWithStore(ModalBuyGiftCertificate);
